<template>
  <main class="page pto">
    <AppBack />

    <AppPageHeader
      :title="`Объект ${currentObject.name}`"
    />

    <section class="section page__content">
      <ThePagePreloader
        v-if="isLoadingObject"
        position="component"
      />

      <div v-else class="info">
        <h2 class="subtitle info__title">
          Основная информация
        </h2>

        <div class="page__row">
          <AppInfoTextBlock
            label-text="Стройка"
            :text="currentObject.building && currentObject.building.name"
          />
        </div>

        <PtoPriceInfoList :data="currentObject"/>
      </div>

      <div class="info" v-if="!isEdit">
        <AppButtonSmEdit
          v-if="$store.getters.rightsPtoAll"
          class="info__btn-edit"
          title="Редактировать"
          @click.native="toggleIsEdit"
        />
        <ul class="info__list-edit">
            <PtoInfoListItem
              label-text="Наименование объекта"
              :text="currentObject.name ? currentObject.name : '-'"
            />

            <PtoInfoListItem
              label-text="Статус"
              :text="currentObject.status ? currentObject.status && currentObject.status.name : '-'"
            />

            <PtoInfoListItem
              label-text="Дата начала"
              :text="currentObject.start_date ? currentObject.start_date : '-'"
            />

            <PtoInfoListItem
              label-text="Дата окончания"
              :text="currentObject.stop_date ? currentObject.stop_date : '-'"
            />

            <PtoInfoListItem
              label-text="Ответственный сметный"
              :text="currentObject.estimate_responsible ? getUserFullName(currentObject.estimate_responsible) : '-'"
            />
            <PtoInfoListItem
              label-text="Договор"
              :text="currentObject.treaty ? currentObject.treaty.treaty_number : '-'"
              is-router-link
              :route="{ name: 'ContractUpdate', params: { id: currentObject.treaty_id } }"
            />

            <PtoInfoListItem
              label-text="Субподрядчик Интекс"
              :text="currentObject.is_intex ? 'Да' : 'Нет'"
            />

            <PtoInfoListItem
              v-if="currentObject.is_intex"
              label-text="Г/П к вычету %"
              :text="currentObject.deduction ? priceFormat(currentObject.deduction) : '-'"
            />

            <PtoInfoListItem
              label-text="Заказчик"
              :text="currentObject.customer ? currentObject.customer && currentObject.customer.long_name : '-'"
            />

            <PtoInfoListItem
              :label-text="currentObject.is_intex ? 'Генподрядчик' : 'Генподрядчик по умолчанию'"
              :text="currentObject.general_contractor ? currentObject.general_contractor && currentObject.general_contractor.long_name : '-'"
            />
        </ul>
      </div>

      <FormPtoObject
        v-if="isEdit"
        :formData="currentObject"
        is-edit
        :is-sending="isSendingRequest"
        @request="updateCurrentItem"
        @cancel="toggleIsEdit"
      />
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between">
        <h2 class="title">
          Проекты
        </h2>

        <PageControlGroup
          v-if="$store.getters.rightsPtoAll"
          :visible-btn-remove="visibleBtnRemove"
          @remove="openConfirmationRemove"
          @add="openModal"
        />
      </div>

      <TableVuex
        namespaced="pto/project"
        :has-checkbox="$store.getters.rightsPtoAll"
      />
    </section>

    <PaginationVuex namespaced="pto/project" />

    <BaseModal
      v-if="isVisibleModal"
      @close="closeModal"
      title="Создать проект"
    >
      <FormPtoProject
        :form-data="formData"
        :is-sending="isSendingRequest"
        is-parent-entity-page
        @request="createSubmit"
        @cancel="closeModal"
      />
    </BaseModal>

    <!--   Confirmation remove   -->
    <transition name="fade">
      <AppConfirmation
        v-if="confirmationRemove.active"
        :text="confirmationRemove.text"
        :is-sending="isSendingRequest"
        @confirm="deleteSelected"
        @reject="closeConfirmationRemove"
      />
    </transition>
  </main>
</template>

<script>
import AppBack from '@/components/page/AppBack'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppInfoTextBlock from '@/components/page/text/AppInfoTextBlock'
import AppPageHeader from '@/components/page/AppPageHeader'
import BaseModal from '@/components/page/modal/base/BaseModal.vue'
import FormPtoObject from '@/components/pto/form/FormPtoObject'
import FormPtoProject from '@/components/pto/form/FormPtoProject'
import PtoPriceInfoList from '@/components/pto/list/PtoPriceInfoList'
import PageControlGroup from '@/components/page/button/PageControlGroup'
import PaginationVuex from '@/components/page/pagination/PaginationVuex'
import PtoInfoListItem from '@/components/pto/listItem/PtoInfoListItem'
import TableVuex from '@/components/page/table/TableVuex'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import { priceFormat } from '@/utils/form/priceFormat'
import { getUserFullName } from '@/utils/user'
import { MIXIN_MODAL } from '@/mixins/modal/mixinModal'
import { MIXIN_MODAL_CONFIRMATION_REMOVE } from '@/mixins/modal/mixinModalConfirmationRemove'
import { MIXIN_PAGE_DETAIL } from '@/mixins/page/mixinPageDetail'
import { MIXIN_PAGE_TABLE_CONTROL_ACTIONS } from '@/mixins/page/mixinPageTableControlActions'

import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'PtoObjectDetailed',
  components: {
    PtoInfoListItem,
    FormPtoProject,
    AppPageHeader,
    AppBack,
    AppButtonSmEdit,
    AppConfirmation,
    AppInfoTextBlock,
    BaseModal,
    FormPtoObject,
    PaginationVuex,
    PageControlGroup,
    PtoPriceInfoList,
    TableVuex,
    ThePagePreloader
  },

  mixins: [
    MIXIN_MODAL,
    MIXIN_MODAL_CONFIRMATION_REMOVE,
    MIXIN_PAGE_DETAIL,
    MIXIN_PAGE_TABLE_CONTROL_ACTIONS
  ],

  data: () => ({
    formData: {}
  }),

  computed: {
    ...mapGetters('pto/object', {
      currentObject: 'getCurrentItem',
      isLoadingObject: 'getIsLoading'
    }),
    ...mapGetters('pto/project', {
      visibleBtnRemove: 'visibleButtonRemoveItems'
    })
  },

  async mounted () {
    await Promise.all([
      this.loadOneItem(this.$route.params.id),
      this.GETBuildingList(),
      this.GETStatusObjectList(),

      this.GETHandbookIDList(),
      this.GETStatusProjectList()
    ])
    await this.loadOneItem(this.$route.params.id)
    this.syncFormData(this.currentObject)

    this.setFilterProject({ object_id: this.$route.params.id })
    await this.loadList()
  },

  destroyed () {
    this.RESET_STORE()
  },

  methods: {
    ...mapActions('handbook/pto', {
      GETBuildingList: 'GETBuildingList',
      GETStatusObjectList: 'GETStatusObjectList',

      GETHandbookIDList: 'GETHandbookIDList',
      GETStatusProjectList: 'GETStatusProjectList'
    }),
    ...mapMutations('pto/project', {
      setFilterProject: 'SET_FILTER_QUERY',
      RESET_STORE: 'RESET_STORE'
    }),

    ...mapActions('pto/object', {
      loadOneItem: 'loadOneItem',
      updateItem: 'updateItem'
    }),
    ...mapActions('pto/project', {
      loadList: 'loadList',
      createItem: 'createItem',
      deleteItems: 'deleteItems',
      loadSearch: 'loadSearch',
      loadFilter: 'loadFilter'
    }),
    getUserFullName,
    priceFormat,

    async createSubmit (data) {
      await this.sendPostRequest(() => this.createItem(data))
      await this.loadList()
    },

    async deleteSelected () {
      await this.sendDeleteRequest(this.deleteItems)
    },

    async updateCurrentItem (data) {
      await this.sendPutRequest(data)
      this.syncFormData(this.currentObject)
    },

    syncFormData (data) {
      const responsible = {
        id: data?.estimate_responsible?.id,
        name: data?.estimate_responsible?.profile?.full_name
      }
      Vue.set(this.formData, 'object', data)
      Vue.set(this.formData, 'building', data.building)
      Vue.set(this.formData, 'accounting_cipher', data.building?.accounting_cipher)
      Vue.set(this.formData, 'estimate_responsible', responsible)
    }
  }
}
</script>
